import { Button, Grid } from "@mui/material";
import GetAppIcon from '@mui/icons-material/GetApp';
import { FC } from "react";
import { FileUpload } from "@mui/icons-material";

interface ReporteComponenteProps {
  importExcel?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  fileInputRef?: React.RefObject<HTMLInputElement>;
  downloadPlantilla?: () => void;
  exportExcel?: () => void;
  downloadPdf?: () => void;
  indexForInputs?: number;
}

const ReporteComponente: FC<ReporteComponenteProps> = ({ fileInputRef,
  importExcel, downloadPlantilla, exportExcel, downloadPdf, indexForInputs=1 }) => {

  return (
    <Grid container alignItems="center">

      {importExcel && fileInputRef && (
        <Grid item >
          <input
            ref={fileInputRef}
            type="file"
            onChange={importExcel}
            style={{ display: 'none' }}
            accept=".xls, .xlsx"
            id={`btn-upload-file-plan-cuenta-${indexForInputs}`}
          />

          <label htmlFor={`btn-upload-file-plan-cuenta-${indexForInputs}`}>
            <Button
              size="small"
              fullWidth
              component="span"
              variant="text"
              color="inherit"
              startIcon={<FileUpload />}
            >
              Importar Excel
            </Button>
          </label>
        </Grid>
      )

      }

      {downloadPlantilla && (
        <Grid item >
          <Button
            variant="contained"
            size="small"
            startIcon={<GetAppIcon />}
            style={{
              color: 'black',
              backgroundColor: 'white',
              boxShadow: 'none',
            }}
            onClick={downloadPlantilla}
          >
            {'Descargar Plantilla'}
          </Button>
        </Grid>
      )

      }

      {
        exportExcel && (
          <Grid item >
            <Button
              variant="contained"
              size="small"
              startIcon={<GetAppIcon />}
              style={{
                color: 'black',
                backgroundColor: 'white',
                boxShadow: 'none',
              }}
              onClick={exportExcel}
            >
              {'Exportar Excel'}
            </Button>
          </Grid>
        )
      }

      {downloadPdf && (
        <Grid item >
          <Button
            variant="contained"
            size="small"
            startIcon={<GetAppIcon />}
            style={{
              color: 'black',
              backgroundColor: 'white',
              boxShadow: 'none',
            }}
            onClick={downloadPdf}
          >
            {'PDF'}
          </Button>
        </Grid>
      )

      }
    </Grid>
  );
}

export default ReporteComponente